import React from "react";
import { Circle, Tooltip } from "react-leaflet";
import { formatNumber } from "../../utils/functions/formatNumber";
import getRadius from "../../utils/functions/getRadius";

export default function TooltipCircle({
  text,
  lat,
  long,
  value,
  max,
  min,
  zoomVal,
  isXeno,
  isVolume,
  language,
}) {
  return (
    <Circle
      center={[lat, long]}
      pathOptions={
        isXeno
          ? { weight: 1, color: "#308144" }
          : { weight: 1, color: "#177CC5" }
      }
      radius={getRadius(max, min, value, zoomVal)}
    >
      <Tooltip>
        <div
          className="round-corners text-align-left"
          style={{ fontSize: "14px" }}
        >
          <span>{text}</span>
          <br />
          {formatNumber(isVolume ? value : value.toFixed(1), language)} tweets
        </div>
      </Tooltip>
    </Circle>
  );
}
